import styled from 'styled-components';
import { defaultTheme } from 'constants/theme/defaultTheme';

interface ExpandableProps {
  expand: boolean;
}

export const Styles = {
  Footer: styled.div<ExpandableProps>`
    width: 100%;
    background: rgba(33, 35, 64, 1)
      radial-gradient(
        133.73% 98.18% at 100% 0%,
        rgba(0, 158, 255, 0.25) 0%,
        rgba(33, 35, 64, 0.25) 100%
      );
    position: fixed;
    transition: max-height 0.2s ease-out;
    height: 100%;
    max-height: 64px;
    padding: ${defaultTheme.spacing(4)};
    padding-right: ${defaultTheme.spacing(
      13,
    )}; // this is to provide space to the absolutely positioned chevron

    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
    ${({ expand }) => {
      return (
        expand &&
        `
        max-height: 184px;
        padding-right: ${defaultTheme.spacing(4)};
        padding-bottom: 0;
        `
      );
    }};
  `,
  Icon: styled.div`
    display: inherit;
  `,
  CollapsedButton: styled.div<ExpandableProps>`
    flex-grow: 1;
    width: 100%;
    max-width: 100px;
    margin-left: ${defaultTheme.spacing(2)};

    ${({ expand }) => {
      return (
        expand &&
        `
        display: none;
`
      );
    }}
  `,
  Content: styled.div<ExpandableProps>`
    display: flex;
    flex-direction: row;
    height: 100%;
    align-items: center;
    justify-content: space-between;
    transition: transform 0.3s ease-out;

    ${({ expand }) => {
      return (
        expand &&
        `
      flex-direction: column;
      align-items: center;
      transform: translateY(-30px);
      justify-content: center;
      `
      );
    }};
  `,
  ExpandedText: styled.div`
    text-align: center;
    padding: ${defaultTheme.spacing(4)} 0;
  `,
  ChevronButton: styled.button`
    position: absolute;
    top: ${defaultTheme.spacing(4)};
    right: ${defaultTheme.spacing(4)};
    padding: ${defaultTheme.spacing(2)};
    border: none;
    background: transparent;
  `,
};
